import { render } from "./GetStartedModal.vue?vue&type=template&id=00bce1d8&scoped=true"
import script from "./GetStartedModal.vue?vue&type=script&lang=js"
export * from "./GetStartedModal.vue?vue&type=script&lang=js"

import "./GetStartedModal.vue?vue&type=style&index=0&id=00bce1d8&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bce1d8"]])

export default __exports__